var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.008 4.92041C12.9001 4.31906 12.3863 3.88113 11.7899 3.74442C10.8976 3.55322 9.24599 3.4165 7.45909 3.4165C5.67324 3.4165 3.99525 3.55322 3.1018 3.74442C2.50652 3.88113 1.99159 4.29129 1.88375 4.92041C1.77484 5.604 1.66699 6.56104 1.66699 7.7915C1.66699 9.02197 1.77484 9.979 1.91018 10.6626C2.01909 11.2639 2.53295 11.7019 3.12823 11.8386C4.07561 12.0298 5.69968 12.1665 7.48658 12.1665C9.27348 12.1665 10.8976 12.0298 11.8449 11.8386C12.4402 11.7019 12.9541 11.2917 13.063 10.6626C13.1708 9.979 13.3062 8.9942 13.3337 7.7915C13.2787 6.56104 13.1433 5.604 13.008 4.92041ZM5.99785 9.70557V5.87744L9.29991 7.7915L5.99785 9.70557Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7e340a81668e22fbee75afc104268e66.svg";
export { ForwardRef as ReactComponent };